<template>
  <div>
    <li class="nav-item">
      <div
        class="nav-link show"
        :class="{ active }"
        @click="$emit('click', name)"
      >
        {{ displayName || name }}
        <span v-if="badge != null && badge > 0" class="tab-badge">{{
          badge
        }}</span>
      </div>
    </li>
  </div>
</template>

<script>
export default {
  props: {
    link: { type: String, default: "" },
    active: { type: Boolean, default: false },
    name: { type: String, default: "" },
    displayName: { type: String, default: null },
    badge: { type: Number, default: null }
  },
  emits: ["click"]
};
</script>

<style lang="scss" scoped>
li.nav-item {
  cursor: pointer;
}
.nav-link {
  color: var(--sera-color-text-body, #6f767b) !important;
  &.active {
    font-weight: bold;
    color: var(---sera-color-core-blue-cobalt-blue-800, #0f3b95) !important;
  }
}
.tab-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  margin-left: 6px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  color: #fff;
  background-color: #dc3545;
  border-radius: 10px;
}
</style>
